//Dependencies
import React, { useState } from 'react';

// Components
import InputField from '../../../global_components/form_components/InputField';
import TextArea from '../../../global_components/form_components/TextArea';

const AddNewCourseContent = () => {
  const [statusMessage, setStatusMessage] = useState("");

  const handleAddNewCourseSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage("");

    const formData = {
      title: e.target.adminAddCourseTitle.value,
      date: e.target.adminAddCourseDate.value,
      time: e.target.adminAddCourseTime.value,
      image: e.target.adminAddCourseImage.value,
      maximumEnrolled: e.target.adminAddCourseMaximumEnrolled.value,
      location: e.target.adminAddCourseLocation.value,
      description: e.target.adminAddCourseDescription.value
    };

    try {
      const response = await fetch("https://wad-backend.ws381566.remote.ac/createNewCourseAdmin.php?adminRequired=true", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
        mode: "cors",
      });

      const result = await response.json();

      if (result.status === "success") {
        setStatusMessage(result.message);
      }
    } catch (error) {
      setStatusMessage(error.message);
    }
  };

  return (
    <div className="flex flex-col items-center justify-start gap-10 w-full">
      <div className="flex flex-col items-start justify-center p-5 sm:p-10 rounded-sm shadow-sm border border-[#DCDCDC] border-b-[#06BD60] border-b-2 w-full max-w-full sm:max-w-2/3 lg:max-w-2/5 bg-white" id="accountInfoContainer">
        <div className="flex flex-col items-start mb-10 w-full">
          <h2 className="text-3xl sm:text-4xl font-semibold mb-4">Add new course</h2>
          <h4 className="text-sm sm:text-base font-normal mb-5">This will add the course to the database</h4>
          <h4 className="text-sm font-normal text-red-500 mb-5">{statusMessage}</h4>
        </div>
        <form className="w-full" onSubmit={handleAddNewCourseSubmit}>
          <InputField for="adminAddCourseTitle" name="adminAddCourseTitle" labelText="Title" inputType="text" inputRequired="required" placeholder="A good title" overrideStyles="mb-4 w-full" />
          <InputField for="adminAddCourseDate" name="adminAddCourseDate" labelText="Date" inputType="date" inputRequired="required" overrideStyles="mb-4 w-full" />
          <InputField for="adminAddCourseTime" name="adminAddCourseTime" labelText="Course duration (hours)" inputType="number" inputRequired="required" placeholder="2" overrideStyles="mb-4 w-full" />
          <InputField for="adminAddCourseLocation" name="adminAddCourseLocation" labelText="Location" inputType="text" inputRequired="required" placeholder="Building 5a" overrideStyles="mb-4 w-full" />
          <InputField for="adminAddCourseImage" name="adminAddCourseImage" labelText="Image link address" inputType="text" inputRequired="required" placeholder="https://path-to-cdn" overrideStyles="mb-4 w-full" />
          <InputField for="adminAddCourseMaximumEnrolled" name="adminAddCourseMaximumEnrolled" labelText="Maximum enrolled" inputType="number" inputRequired="required" placeholder="100" overrideStyles="mb-4 w-full" />
          <TextArea for="adminAddCourseDescription" name="adminAddCourseDescription" labelText="Description" inputRequired="required" placeholder="A short description" overrideStyles="mb-4 w-full" />
          <button className="py-2 px-5 bg-[#06BD60] text-white rounded-sm font-semibold cursor-pointer mt-5 w-full sm:w-auto" type="submit">
            Save
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNewCourseContent;